
export function Contact() {
  return (
    <section id="contact" className="py-32 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-amber-500 text-sm font-semibold tracking-widest uppercase mb-4">
            CONTACT
          </p>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            お問い合わせ
          </h2>
          <p className="text-xl text-gray-300">
            奄美薬剤師会へのお問い合わせはこちらから
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-3xl p-10 border border-slate-700/50">
            <h3 className="text-2xl font-bold text-white mb-8">事務局情報</h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500/10 rounded-xl flex-shrink-0">
                  <i className="ri-building-line text-2xl text-teal-400"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-sm mb-1">組織名</p>
                  <p className="text-white text-lg font-medium">鹿児島県奄美薬剤師会事務局</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500/10 rounded-xl flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-teal-400"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-sm mb-1">電話番号</p>
                  <a href="tel:0997-53-3417" className="text-white text-lg font-medium hover:text-teal-400 transition-colors">
                    0997-53-3417
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500/10 rounded-xl flex-shrink-0">
                  <i className="ri-mail-line text-2xl text-teal-400"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-sm mb-1">メールアドレス</p>
                  <a href="mailto:amamipa@gmail.com" className="text-white text-lg font-medium hover:text-teal-400 transition-colors break-all">
                    amamipa@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500/10 rounded-xl flex-shrink-0">
                  <i className="ri-time-line text-2xl text-teal-400"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-sm mb-1">受付時間</p>
                  <p className="text-white text-lg font-medium">平日 9:00 - 17:00</p>
                </div>
              </div>
            </div>

            <div className="mt-10 pt-10 border-t border-slate-700">
              <h4 className="text-xl font-bold text-white mb-4">学生の皆様へ</h4>
              <p className="text-gray-300 leading-relaxed">
                医療関係の学生の方々も大歓迎です。奄美大島での薬剤師としてのキャリアや研修プログラムについて、お気軽にお問い合わせください。未来の医療を一緒に支えましょう。
              </p>
            </div>
          </div>

          <div className="bg-slate-800/50 backdrop-blur-sm rounded-3xl p-10 border border-slate-700/50">
            <h3 className="text-2xl font-bold text-white mb-8">奄美大島へのアクセス</h3>
            <div className="w-full h-96 rounded-2xl overflow-hidden mb-6">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115089.89474847!2d129.41!3d28.38!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x353e6e3e3e3e3e3e%3A0x3e3e3e3e3e3e3e3e!2z5aWE576O5aSn5bO2!5e0!3m2!1sja!2sjp!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="奄美大島の地図"
              ></iframe>
            </div>
            <div className="bg-teal-500/10 rounded-2xl p-6 border border-teal-500/20">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-2xl text-teal-400 flex-shrink-0 mt-1"></i>
                <div>
                  <p className="text-white font-medium mb-2">所在地</p>
                  <p className="text-gray-300">
                    鹿児島県奄美市名瀬
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
